import { queryClient } from 'queryClient';
import type { Country } from '@packages/domain/models/country';
import type { Currency } from '@packages/domain/models/currency';
import { queryKeys } from 'hooks/queryKeys';
import type { RootState } from 'reducers/types';
import { getRecipient } from 'selectors/entities/recipient/recipient';
import { getCurrentLocale, getFieldValue } from 'selectors/ui/ui';
import { currenciesCache } from './currenciesCache';

export const currencyLookup = {
  byCode: (code: string): Currency => currenciesCache.byCode(code),

  current: (state: RootState): Currency =>
    currencyLookup.byCode(getRecipient(state)?.currency as string),

  localCode: (state: RootState): string => {
    const countryCode = getFieldValue(state, 'sender_country');
    const countries =
      queryClient.getQueryData<Country[]>(
        queryKeys.countries.all(getCurrentLocale(state)),
      ) ?? [];
    return countries.find(c => c.code === countryCode)?.currency ?? '';
  },

  local: (state: RootState): Currency =>
    currencyLookup.byCode(currencyLookup.localCode(state)),
};
